import * as React from "react";
import "../scss/fullscreen.scss"

export interface FullscreenProps {
    headerText: string;
    infoText: string;
}
export class FullscreenComponent extends React.Component<FullscreenProps, {}> {

    public render() {
        return (
            <div className="container">
                <div className="fullscreen">
                    <div className="headerText">
                        <span>{this.props.headerText}</span>
                    </div>
                    <br></br>
                    <div className="infoText">
                        <span>{this.props.infoText}</span>
                    </div>
                </div>
            </div>
        )
    }
}
export default FullscreenComponent;